import { render } from "./RatingGraph.vue?vue&type=template&id=69548d28&scoped=true"
import script from "./RatingGraph.vue?vue&type=script&lang=js"
export * from "./RatingGraph.vue?vue&type=script&lang=js"

import "./RatingGraph.vue?vue&type=style&index=0&id=69548d28&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69548d28"]])

export default __exports__